import { useState } from "react";

export default function CompanyLogo({ company }) {
  const [isFallback, setIsFallback] = useState(false);

  const handleError = (e) => {
    if (company?.companyLogoURL) {
      e.currentTarget.src = company.companyLogoURL;
      setIsFallback(true);
    }
  };

  return (
    <img
      src="/logo.png"
      onError={handleError}
      style={
        isFallback && company?.logoWidth
          ? { maxWidth: `${company.logoWidth}px` }
          : {maxWidth: "200px", maxHeight: "50px", display: "flex", margin: "auto"}
      }
      alt="Company Logo"
    />
  );
}
